import React from 'react'
import moment from 'moment'
import { MDBTable, MDBTableBody } from 'mdbreact';
import BotonesFormulario from '../componentes/BotonesFormulario'
import HeaderTabla from '../componentes/HeaderTabla'
import { TraeNombre } from '../hooks/Funciones'

const VerCupon = ({ data, seleccionaRegistro, baseUrl }) => {
	return (
		<MDBTable hover responsive>
			<HeaderTabla array={['Id', 'Nombre', 'Codigo descuento', 'Activo', 'Fecha termino', 'Porcentaje', '']} />
			<MDBTableBody>

				{data.map((item, index) => {
					return (
						<tr key={index} className="tabla_productos">
							<td>{item.id}</td>
							<td>{item.nombre}</td>
							<td>{item.codigo}</td>
							<td>{item.activo === 'true' ? 'Si' : 'No'}</td>
							<td>{moment(item.fechatermino).format('DD/MM/YYYY HH:mm:ss')}</td>
							<td>{item.porcentaje === 'true' ? 'Si' : 'No'}</td>
							<td className="tabla_funciones">
								<BotonesFormulario SeleccionarCategoria={seleccionaRegistro} item={item} Roll={'Admin'} />
							</td>
						</tr>
					)
				})}

			</MDBTableBody>
		</MDBTable>
	)
}

export default VerCupon